import { render } from "./Welcome.vue?vue&type=template&id=50f1ac58&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=ts"
export * from "./Welcome.vue?vue&type=script&lang=ts"

import "./Welcome.vue?vue&type=style&index=0&id=50f1ac58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50f1ac58"

export default script